module.exports = __webpack_public_path__ + "den_930_180-e840d343fcf7721ca030f47ca428163d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/den_930_180.png
// module id = 1370
// module chunks = 1